import React from 'react';
import Table from '../../common/TablePerformance';
import { connect } from 'react-redux';
import { REDUCER_NAME, changeSortState } from '../reducer';
import Const from './Const';

const getDataFromRedux = state =>
  state[REDUCER_NAME].listObjectDataTopNewLowByTicker;

function TablePerformanceNewLow(props) {
  const { listId, isLoading, changeSortState, sortState } = props;

  return (
    <Table
      onSort={changeSortState}
      sortState={sortState}
      listId={listId}
      isLoading={isLoading}
      getDataFromRedux={getDataFromRedux}
      listColumns={Const.listColumn}
      resizable={true}
      columnDraggable={false}
      rowDraggable={false}
      i18nTitleKey="topVolume.performance.listTitleTable"
    />
  );
}

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataTopNewLowTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TablePerformanceNewLow);
